import { NgModule } from '@angular/core';
import { DragAndDropManagerDirective } from '@core/modules/drag-and-drop-manager/drag-and-drop-manager.directive';
import { DragAndDropManagerRootDirective } from '@core/modules/drag-and-drop-manager/drag-and-drop-manager-root.directive';
import { DragAndDropManagerService } from '@core/modules/drag-and-drop-manager/drag-and-drop-manager.service';

@NgModule({
    declarations: [
        DragAndDropManagerDirective,
        DragAndDropManagerRootDirective
    ],
    imports: [],
    exports: [
        DragAndDropManagerDirective,
        DragAndDropManagerRootDirective
    ],
    providers: [
        DragAndDropManagerService
    ]
})
export class DragAndDropManagerModule {}
